module.exports = __webpack_public_path__ + "img/EXTERIOR-FRONX-BOOSTERGREEN-5.1e7343fa.jpg";